module.exports = __webpack_public_path__ + "static/media/recommends_02_your_team_decide.143294ea.png";